export const userTags = {
  USERS: 'Users',
  USER_RECORD: 'UserRecord',
};
